export const firebaseConfig = {
  apiKey: 'AIzaSyDbjIg3WcJL3VqrhHvukiOV4rRUhznVmb8',
  authDomain: 'visionwizard-bible.firebaseapp.com',
  projectId: 'visionwizard-bible',
  storageBucket: 'visionwizard-bible.appspot.com',
  messagingSenderId: '504712200577',
  appId: '1:504712200577:web:2c549d4abbcf195e25a880',
  measurementId: 'G-QBVL7RQ7VG',
}
